import React, { useRef, useState } from "react";
import { debtApi } from "../../lib/api";
import { toast } from "sonner";
import { Paperclip, FileText, X } from "lucide-react";

export const Attachments = ({ lead, onChange, compact }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const files = lead.attachments || [];
  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    try { const meta = await debtApi.upload(lead.id, f); onChange({ ...lead, attachments: [...files, meta] }); toast.success(`${meta.name} attached`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Upload failed"); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async (fid) => { await debtApi.removeFile(fid); onChange({ ...lead, attachments: files.filter((x) => x.id !== fid) }); };
  return (
    <div className={`att ${compact ? "compact" : ""}`} data-testid={`att-${lead.id}`}>
      {files.map((f) => (
        <span key={f.id} className="att-chip" title={`${f.name} · ${(f.size / 1024).toFixed(0)} KB · ${(f.at || "").slice(0, 10)}`}>
          <button className="att-open" onClick={() => debtApi.openFile(f.id)} data-testid={`att-open-${f.id}`}><FileText size={11} />{compact ? "" : f.name}</button>
          <button className="att-x" onClick={() => remove(f.id)} title="Remove" data-testid={`att-remove-${f.id}`}><X size={10} /></button>
        </span>
      ))}
      <button className="btn btn-sm att-add" onClick={() => ref.current?.click()} disabled={busy} title="Attach term sheet" data-testid={`att-add-${lead.id}`}><Paperclip size={11} />{busy ? "…" : compact ? (files.length ? "" : "Attach") : "Attach term sheet"}</button>
      <input ref={ref} type="file" accept=".pdf,.doc,.docx,.xlsx,.xls,.png,.jpg,.jpeg,.msg,.eml" style={{ display: "none" }} onChange={(e) => upload(e.target.files?.[0])} data-testid={`att-input-${lead.id}`} />
    </div>
  );
};
